import { createBindingContext, IEntity } from "@odata/BindingContext";
import { expandEnumProps } from "@odata/Data.utils";
import { EntitySetName, IUserEntity, OdataActionName } from "@odata/GeneratedEntityTypes";
import { ODataQueryResult, parseError } from "@odata/ODataParser";
import { SendToEmployeeActionType } from "@pages/payroll/employee/Employee.utils";
import { sendToEmployeeMailPath } from "@pages/payroll/employee/SendToEmployee.def";
import { isObjectEmpty } from "@utils/general";

import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import DialogFormView, { IDialogFormViewProps } from "../../../views/formView/DialogFormView";
import { getAlertFromError } from "../../../views/formView/Form.utils";
import { IFormStorageSaveResult } from "../../../views/formView/FormStorage";

interface IProps extends IDialogFormViewProps<IEntity> {
    employeeDialogType?: SendToEmployeeActionType;
}

class SendToEmployeeFormView extends DialogFormView<IEntity, IProps> {
    save = async (): Promise<IFormStorageSaveResult> => {
        const { storage } = this.props;
        const validationRes = await storage.validateAll();
        if (validationRes.hasError) {
            storage.refresh();
            return null;
        }

        const isInvitation = this.props.employeeDialogType === SendToEmployeeActionType.SendEmployeeInvitation;

        const action = isInvitation ? OdataActionName.PrEmployeeInviteToCustomerPortal : OdataActionName.PrEmployeeSendPayslipPassword;
        const emailBc = storage.data.bindingContext.navigate(sendToEmployeeMailPath);
        const email = storage.getValue(emailBc);
        try {
            const res = await storage.oData.getEntitySetWrapper(EntitySetName.PrEmployees).action(
                action,
                this.entity.Id,
                { Email: email }
            ) as ODataQueryResult<IUserEntity>;

            if (!isObjectEmpty(res.value)) {
                const user = res.value;
                expandEnumProps(user, createBindingContext(EntitySetName.Users, storage.oData.metadata));
                this.props.onAfterConfirm(user);
            } else {
                // sending password does not return a user entity, so we just call onAfterConfirm with an empty object to indicate success
                this.props.onAfterConfirm({});
            }
        } catch (e) {
            const error = parseError(e);
            const errorAlert = getAlertFromError(error);
            storage.setFormAlert(errorAlert);
        }
        return null;
    };
}

export default withPermissionContext(SendToEmployeeFormView);